import React from "react";
import {
    Bar,
    BarChart, ComposedChart, LabelList,

    Legend, Line, ReferenceLine, Tooltip,


    XAxis, YAxis,

} from "recharts";
import {Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import {format, parseISO} from "date-fns";




const SerrasBarChart = (props) => {

    const  data  = props.data? props.data : [];

    const width = props.width? props.width : 300;
    const height = props.height? props.height : 300;
    const titulo = props.titulo? props.titulo : '';
    const maxBarSize = props.maxBarSize? { maxBarSize: props.maxBarSize} : {}

    const calcCorrecao = data => {
        return (data.qtde<0)? data.qtde * -1 : data.qtde ;
    }

    const xdado = data => {
        return `${data.fabricante? data.fabricante : '--'} - ${data.data? format(parseISO(data.data),"dd-MM-yyyy") : '' }`
    }

    const roundMM = data => {
        return Math.round(data.sumMilimetrosRaspados)
    }

    const labelCalc = data => {
        return `${data.qtdePneus}pneus - ${Math.round(data.sumMilimetrosRaspados)}mm`
    }

    return(
        <Grid container item style={{backgroundColor: "white", width: width, height: height }}>
            <Grid container item justifyContent={"center"}>
                <Typography># RASPAGENS  POR SERRA E mm RASPADOS</Typography>
            </Grid>
            <Grid item style={ {width: "100%", height: "100%", padding: 10}}>
                <ComposedChart
                    width={width}
                    height={height-30 }
                    data={data}
                    layout={"vertical"}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                >

                    <XAxis type="number" hide />
                    <XAxis xAxisId={1} type="number" hide />
                    <YAxis type="category" minTickGap={1} tickCount={1} width={300} padding={{ left: 0 }} dataKey={xdado}/>
                    <Bar dataKey={"qtdePneus"} isAnimationActive={false} layout={"vertical"}
                           fill="#a8adb3" {...maxBarSize}  >
                        <LabelList dataKey={labelCalc} position="insideLeft" />
                    </Bar>

                </ComposedChart>


            </Grid>
        </Grid>
    );

}

/*
    <Line type="monotone"   isAnimationActive={false} xAxisId={1} dataKey={roundMM} stroke="#ff7300" label={{ position: 'top', fill:'black' }}  />

 */

export default SerrasBarChart;